"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPackagingMethodPreview = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const clickElementByClickTypeAndPackagingMethod = {
    [enums_1.ClickType.Open]: {
        [enums_1.PackagingMethod.Pdf]: enums_1.ClickElement.OpenPDFPreview,
        [enums_1.PackagingMethod.Envelope]: enums_1.ClickElement.OpenPrintedVoucherPreview,
        [enums_1.PackagingMethod.GiftBox]: enums_1.ClickElement.OpenPrintedVoucherPreview,
    },
    [enums_1.ClickType.Close]: {
        [enums_1.PackagingMethod.Pdf]: enums_1.ClickElement.ClosePDFPreview,
        [enums_1.PackagingMethod.Envelope]: enums_1.ClickElement.ClosePrintedVoucherPreview,
        [enums_1.PackagingMethod.GiftBox]: enums_1.ClickElement.ClosePrintedVoucherPreview,
    },
};
function trackPackagingMethodPreview(packagingMethod, clickType = enums_1.ClickType.Open) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            eventName: enums_1.GA4EventName.ShowPopup,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_type: clickType,
            click_element: clickElementByClickTypeAndPackagingMethod[clickType][packagingMethod],
        },
    });
}
exports.trackPackagingMethodPreview = trackPackagingMethodPreview;
//# sourceMappingURL=trackPackagingMethodPreview.js.map